import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** information circle. Decorative line icon; always pair with a visible text label. */
export function InfoIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 11v5" />
      <path d="M12 7.8v.01" />
    </IconSvg>
  )
}
